(ns lemonpi.schema.interface
  (:require [malli.core :as m]
            [malli.registry :as mr]))

(def -registry (atom {}))

(defn -reset-registry! []
  (reset! -registry {}))

(defn register!
  "Registers malli schemas into a global schema registry.

      (schema/register! ::kikka :int)
      (schema/register! {::kikka :int, ::kukka :string})"
  ([schemas]
   (doseq [[type schema] schemas]
     (register! type schema)))
  ([type schema]
   (swap! -registry assoc type schema)))

(mr/set-default-registry!
 ;; linear search
 (mr/composite-registry
  ;; base schemas
  (m/default-schemas)
  ;; mutable (spec-like) registry
  (mr/mutable-registry -registry)
  ;; on the perils of dynamic scope
  (mr/dynamic-registry)))
